import PropTypes from "prop-types"
import styled from "@emotion/styled"
import { sizer, getTextSize, getLineHeight } from "@ninjaone/utils"
import { InputErrorIcon } from "@ninjaone/icons"
import Tooltip from "./Tooltip"

import { StyledErrorIcon, StyledInputWrapper } from "./Styled"

export const StyledInput = styled.input`
  width: 100%;
  outline: none;
  background-color: ${({ theme }) => theme.color.background};
  border: 1px solid
    ${({ theme, errorMessage, invalid }) => (errorMessage || invalid ? theme.color.red : theme.color.border)};
  border-radius: ${sizer(1)};
  padding: ${sizer(3)};
  padding-right: ${({ hasIcon }) => (hasIcon ? sizer(10) : sizer(3))};
  min-width: ${({ minWidth }) => minWidth || sizer(75)};
  font-size: ${({ size }) => getTextSize(size || "sm")};
  font-weight: 400;
  user-select: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: ${({ size }) => getLineHeight(size || "sm")};
  letter-spacing: normal;
  color: ${({ color, theme }) => (color ? theme.color[color] : "")};
  margin: 0;

  ::placeholder {
    color: ${({ theme }) => theme.color.gray};
  }
`

export default function Input(props) {
  const { errorMessage } = props

  return (
    <StyledInputWrapper>
      <StyledInput {...props} hasIcon={errorMessage} />

      {errorMessage && (
        <StyledErrorIcon>
          <Tooltip label={errorMessage} isErrorMessage>
            <InputErrorIcon />
          </Tooltip>
        </StyledErrorIcon>
      )}
    </StyledInputWrapper>
  )
}

Input.propTypes = {
  errorMessage: PropTypes.string,
}
